<template>
	<div class="tcp-page tcp-rituals">
		<section class="tcp-rituals__hero">
			<span class="tcp-rituals__badge">Wellness Journal</span>
			<h1>Rituals</h1>
			<p>Thoughtful guides and practices to help you build meaningful wellness rituals. From morning routines to evening wind-downs, discover intentional ways to nourish your body and mind.</p>
		</section>

		<section v-if="featured" class="tcp-rituals__feature">
			<router-link :to="'/rituals/' + featured.id" class="tcp-rituals__feature-link">
				<div class="tcp-rituals__feature-media">
					<img v-if="featured.image_url" :src="featured.image_url" :alt="featured.title">
					<span class="tcp-rituals__pill tcp-rituals__pill--solid">Featured</span>
				</div>
				<div class="tcp-rituals__feature-copy">
					<div class="tcp-rituals__meta">
						<span v-if="featured.category" class="tcp-rituals__pill">{{ featured.category }}</span>
						<span v-if="featured.read_time"><i class="fa fa-clock-o"></i> {{ featured.read_time }}</span>
					</div>
					<h2>{{ featured.title }}</h2>
					<p v-if="featured.excerpt">{{ featured.excerpt }}</p>
					<div class="tcp-rituals__byline">
						<span v-if="featured.author"><i class="fa fa-user-o"></i> {{ featured.author }}</span>
						<span v-if="featured.author && featured.date">•</span>
						<span v-if="featured.date">{{ featured.date }}</span>
					</div>
					<span class="tcp-rituals__read">Read Article <i class="fa fa-arrow-right"></i></span>
				</div>
			</router-link>
		</section>

		<section v-if="categories.length" class="tcp-rituals__filters">
			<button type="button" :class="{ 'is-active': !category }" @click="setCategory('')">All</button>
			<button
				v-for="name in categories"
				:key="name"
				type="button"
				:class="{ 'is-active': category === name }"
				@click="setCategory(name)"
			>{{ name }}</button>
		</section>

		<section class="tcp-rituals__list">
			<div v-if="visible.length" class="tcp-rituals__grid">
				<router-link v-for="item in visible" :key="item.id" :to="'/rituals/' + item.id" class="tcp-ritual-card">
					<div class="tcp-ritual-card__media">
						<img v-if="item.image_url" :src="item.image_url" :alt="item.title">
					</div>
					<div class="tcp-rituals__meta">
						<span v-if="item.category" class="tcp-rituals__pill">{{ item.category }}</span>
						<span v-if="item.read_time"><i class="fa fa-clock-o"></i> {{ item.read_time }}</span>
					</div>
					<h3>{{ item.title }}</h3>
					<p v-if="item.excerpt">{{ item.excerpt }}</p>
					<div class="tcp-rituals__byline">
						<span v-if="item.author"><i class="fa fa-user-o"></i> {{ item.author }}</span>
						<span v-if="item.author && item.date">•</span>
						<span v-if="item.date">{{ item.date }}</span>
					</div>
				</router-link>
			</div>
			<p v-else-if="!loading && !featured" class="tcp-empty">{{ emptyLabel }}</p>
			<div v-if="hasMore" class="tcp-rituals__more">
				<button type="button" class="tcp-btn tcp-btn--outline" @click="shown += 6">Load More Articles</button>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	data() {
		return {
			rows: [],
			category: '',
			shown: 6,
			loading: true
		}
	},
	computed: {
		categories() {
			const names = this.rows.map(row => row.category).filter(Boolean)
			return [...new Set(names)]
		},
		pool() {
			if (!this.category) return this.rows
			return this.rows.filter(row => row.category === this.category)
		},
		featured() {
			return this.pool.find(row => row.featured) || this.pool[0] || null
		},
		grid() {
			if (!this.featured) return []
			return this.pool.filter(row => row.id !== this.featured.id)
		},
		visible() {
			return this.grid.slice(0, this.shown)
		},
		hasMore() {
			return this.grid.length > this.shown
		},
		emptyLabel() {
			return this.rows.length ? 'No rituals in this category.' : 'No rituals published yet.'
		}
	},
	mounted() {
		axios.get(tools.url('/api/store/rituals')).then((response) => {
			this.rows = response.data || []
			this.loading = false
		}).catch(() => {
			this.loading = false
		})
	},
	methods: {
		setCategory(name) {
			this.category = name
			this.shown = 6
		}
	}
}
</script>
